<div class="page-heading">
  <h4 class="page-title text-left">
    <i class="fab fa-whatsapp fa-lg" style="color: #25D366;"></i> Templates Whatsapp
  </h4>
  <p class="page-subtitle">
    Gerencie os templates aprovados pela Meta, sincronize mudanças e envie testes quando estiver em conta sandbox.
  </p>
</div>

<div class="whatsapp-signup-container templates-whatsapp-page">
  <div *ngIf="carregando" class="loading-modern">
    <div class="spinner-modern"></div>
    <p>Carregando dados do WhatsApp...</p>
  </div>

  <ng-container *ngIf="!carregando && !dadosIntegracao.associado">
    <div class="templates-connect-card">
      <div class="templates-connect-shell">
        <div class="templates-connect-hero">
          <div class="templates-connect-icon-wrap">
            <span class="templates-connect-kicker">Integração necessária</span>
            <div class="templates-connect-icon">
              <i class="fab fa-whatsapp"></i>
            </div>
          </div>

          <div class="templates-connect-copy">
            <h5>Conecte seu WhatsApp para gerenciar templates</h5>
            <p>Antes de criar, sincronizar ou editar templates, finalize a integração do WhatsApp Business na tela de configurações.</p>
          </div>
        </div>

        <div class="templates-connect-highlights">
          <div class="templates-connect-highlight">
            <div class="templates-connect-highlight-icon">
              <i class="fas fa-file-medical"></i>
            </div>
            <div>
              <strong>Criar templates oficiais</strong>
              <span>Cadastre modelos aprovados pela Meta para uso fora da janela de 24 horas.</span>
            </div>
          </div>

          <div class="templates-connect-highlight">
            <div class="templates-connect-highlight-icon">
              <i class="fas fa-sync-alt"></i>
            </div>
            <div>
              <strong>Sincronizar status</strong>
              <span>Acompanhe aprovações, reprovações e mudanças direto da Cloud API oficial.</span>
            </div>
          </div>

          <div class="templates-connect-highlight">
            <div class="templates-connect-highlight-icon">
              <i class="far fa-edit"></i>
            </div>
            <div>
              <strong>Editar com segurança</strong>
              <span>Abra o editor com o contexto correto da conta conectada e mantenha tudo consistente.</span>
            </div>
          </div>
        </div>

        <div class="templates-connect-footer">
          <div class="templates-connect-status">
            <i class="fas fa-circle"></i>
            Cloud API oficial não conectada
          </div>

          <button type="button" class="templates-connect-action" (click)="irParaConfiguracoes()">
            <span class="templates-connect-action-icon">
              <i class="fas fa-cog"></i>
            </span>
            <span class="templates-connect-action-copy">
              <strong>Configurar WhatsApp Cloud API</strong>
              <small>Abrir integrações e concluir a conexão oficial</small>
            </span>
            <span class="templates-connect-action-arrow">
              <i class="fas fa-arrow-right"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!carregando && dadosIntegracao.associado">
    <div class="templates-info-modern">
      <i class="fas fa-lightbulb"></i>
      <div class="templates-info-copy">
        <span>
          Esta tela concentra a gestão dos templates Cloud WhatsApp usados fora da janela de 24 horas.
        </span>
        <div class="templates-info-meta">
          <span class="templates-info-context" *ngIf="telefonePrincipalTemplates as telefonePrincipal">
            Ao abrir a Meta, selecione o número
            <strong>{{ telefonePrincipal.nome || telefonePrincipal.telefone }}</strong>
            <ng-container *ngIf="telefonePrincipal.nome && telefonePrincipal.telefone">
              ({{ telefonePrincipal.telefone }})
            </ng-container>
            no canto superior direito.
          </span>
          <span class="templates-info-context" *ngIf="!telefonePrincipalTemplates">
            Ao abrir a Meta, selecione a conta do WhatsApp conectada no canto superior direito.
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="carregandoTemplates" class="loading-modern">
      <div class="spinner-modern"></div>
      <p>Carregando status dos templates...</p>
    </div>

    <div *ngIf="!carregandoTemplates && !statusTemplates.configurado" class="templates-empty-state">
      <div class="empty-icon">
        <i class="fas fa-file-medical"></i>
      </div>
      <h5>Templates não configurados</h5>
      <p>Você ainda não possui templates de notificação criados. Crie os templates para enviar notificações fora da janela de 24 horas.</p>
      <div class="empty-actions">
        <button
          class="btn-create-templates"
          (click)="crieTemplates()"
          [disabled]="criandoTemplates || sincronizandoTemplates">
          <i class="fas" [ngClass]="{'fa-plus': !criandoTemplates, 'fa-spinner fa-spin': criandoTemplates}"></i>
          {{ criandoTemplates ? 'Criando templates...' : 'Criar Templates' }}
        </button>

        <button
          class="btn-empty-sync"
          (click)="sincronizeStatusTemplates()"
          [disabled]="sincronizandoTemplates || criandoTemplates || carregandoTemplates">
          <i class="fas" [ngClass]="{'fa-sync-alt': !sincronizandoTemplates, 'fa-spinner fa-spin': sincronizandoTemplates}"></i>
          {{ sincronizandoTemplates ? 'Sincronizando...' : 'Sincronizar templates' }}
        </button>
      </div>
    </div>

    <div *ngIf="!carregandoTemplates && statusTemplates.configurado" class="templates-configured-modern">
      <div class="templates-toolbar">
        <div class="templates-toolbar-copy">
          <div class="templates-toolbar-label">TEMPLATES CADASTRADOS</div>
          <div class="templates-toolbar-meta">
            <span>{{ statusTemplates.templates.length }} templates</span>
            <span class="templates-mode-badge">
              <i class="fas fa-layer-group"></i>
              Modo: {{ statusTemplates.modo === 'unica' ? 'Único' : 'por status' }}
            </span>
            <span class="templates-pending-text" *ngIf="quantidadeTemplatesPendentes > 0">
              {{ quantidadeTemplatesPendentes }} aguardando aprovação
            </span>
          </div>
        </div>

        <div class="templates-toolbar-search">
          <i class="fas fa-search"></i>
          <input
            type="text"
            [(ngModel)]="buscaTemplates"
            placeholder="Buscar template por nome, texto ou categoria" />
          <button
            *ngIf="buscaTemplates"
            type="button"
            class="btn-clear-search"
            (click)="buscaTemplates = ''"
            title="Limpar busca">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="templates-toolbar-actions">
          <button
            class="btn-sync"
            (click)="sincronizeStatusTemplates()"
            [disabled]="sincronizandoTemplates || carregandoTemplates">
            <i class="fas" [ngClass]="{'fa-sync-alt': !sincronizandoTemplates, 'fa-spinner fa-spin': sincronizandoTemplates}"></i>
            {{ sincronizandoTemplates ? 'Sincronizando...' : 'Sincronizar templates' }}
          </button>
          <button
            type="button"
            class="btn-sync"
            (click)="abrirGerenciadorTemplatesMeta()">
            <i class="fas fa-external-link-alt"></i>
            Gerenciar na Meta
          </button>
          <button
            class="btn-sync"
            (click)="sincronizeDoFacebook()"
            [disabled]="sincronizandoDoFacebook || carregandoTemplates">
            <i class="fas" [ngClass]="{'fa-download': !sincronizandoDoFacebook, 'fa-spinner fa-spin': sincronizandoDoFacebook}"></i>
            {{ sincronizandoDoFacebook ? 'Importando...' : 'Importar da Meta' }}
          </button>
        </div>
      </div>

      <div class="reference-template-groups">
        <div class="reference-template-group" *ngIf="templatesFluxoPedido.length > 0">
          <h5>FLUXO DO PEDIDO</h5>
          <div class="reference-template-list">
            <div class="reference-template-row" *ngFor="let template of templatesFluxoPedido">
              <div class="reference-template-main">
                <div class="reference-template-icon utility" kendoTooltip title="Template aprovado&#10;Pronto para uso no WhatsApp">
                  <i class="fas fa-check"></i>
                </div>
                <div class="reference-template-copy">
                  <strong>{{ obtenhaDescricaoTipoNotificacao(template.tipoNotificacao) }}</strong>
                  <p>{{ template.textoMensagem || template.mensagem || 'Sem conteúdo de texto definido.' }}</p>
                </div>
              </div>
              <div class="reference-template-side">
                <span class="reference-template-status" [ngClass]="obtenhaClasseStatusTemplate(template.status || '')">
                  {{ obtenhaDescricaoStatusTemplate(template.status || '') }}
                </span>
                <span class="reference-template-category utility">$ Utilidade</span>
                <div class="reference-template-actions">
                  <button
                    *ngIf="podeExibirBotaoTesteTemplate(template)"
                    class="reference-template-test"
                    kendoTooltip
                    title="Enviar mensagem de teste"
                    [disabled]="!podeEnviarTesteTemplate(template) || enviandoTesteTemplate"
                    (click)="abrirModalEnviarTesteTemplate(template)">
                    <i class="fas" [ngClass]="enviandoTesteTemplateId === template.id ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                  </button>
                  <button class="reference-template-edit" (click)="abrirEditorTemplate(template)" title="Editar">
                    <i class="far fa-edit"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reference-template-group" *ngIf="templatesRastreamento.length > 0">
          <h5>RASTREAMENTO</h5>
          <div class="reference-template-list">
            <div class="reference-template-row" *ngFor="let template of templatesRastreamento">
              <div class="reference-template-main">
                <div class="reference-template-icon utility" kendoTooltip title="Template aprovado&#10;Pronto para uso no WhatsApp">
                  <i class="fas fa-check"></i>
                </div>
                <div class="reference-template-copy">
                  <strong>{{ obtenhaDescricaoTipoNotificacao(template.tipoNotificacao) }}</strong>
                  <p>{{ template.textoMensagem || template.mensagem || 'Sem conteúdo de texto definido.' }}</p>
                </div>
              </div>
              <div class="reference-template-side">
                <span class="reference-template-status" [ngClass]="obtenhaClasseStatusTemplate(template.status || '')">
                  {{ obtenhaDescricaoStatusTemplate(template.status || '') }}
                </span>
                <span class="reference-template-category utility">$ Utilidade</span>
                <div class="reference-template-actions">
                  <button
                    *ngIf="podeExibirBotaoTesteTemplate(template)"
                    class="reference-template-test"
                    kendoTooltip
                    title="Enviar mensagem de teste"
                    [disabled]="!podeEnviarTesteTemplate(template) || enviandoTesteTemplate"
                    (click)="abrirModalEnviarTesteTemplate(template)">
                    <i class="fas" [ngClass]="enviandoTesteTemplateId === template.id ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                  </button>
                  <button class="reference-template-edit" (click)="abrirEditorTemplate(template)" title="Editar">
                    <i class="far fa-edit"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reference-template-group" *ngIf="templatesFidelidade.length > 0">
          <h5>FIDELIDADE</h5>
          <div class="reference-template-list">
            <div class="reference-template-row" *ngFor="let template of templatesFidelidade">
              <div class="reference-template-main">
                <div class="reference-template-icon utility" kendoTooltip title="Template aprovado&#10;Pronto para uso no WhatsApp">
                  <i class="fas fa-check"></i>
                </div>
                <div class="reference-template-copy">
                  <strong>{{ obtenhaDescricaoTipoNotificacao(template.tipoNotificacao) }}</strong>
                  <p>{{ template.textoMensagem || template.mensagem || 'Sem conteúdo de texto definido.' }}</p>
                </div>
              </div>
              <div class="reference-template-side">
                <span class="reference-template-status" [ngClass]="obtenhaClasseStatusTemplate(template.status || '')">
                  {{ obtenhaDescricaoStatusTemplate(template.status || '') }}
                </span>
                <span class="reference-template-category utility">$ Utilidade</span>
                <div class="reference-template-actions">
                  <button
                    *ngIf="podeExibirBotaoTesteTemplate(template)"
                    class="reference-template-test"
                    kendoTooltip
                    title="Enviar mensagem de teste"
                    [disabled]="!podeEnviarTesteTemplate(template) || enviandoTesteTemplate"
                    (click)="abrirModalEnviarTesteTemplate(template)">
                    <i class="fas" [ngClass]="enviandoTesteTemplateId === template.id ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                  </button>
                  <button class="reference-template-edit" (click)="abrirEditorTemplate(template)" title="Editar">
                    <i class="far fa-edit"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reference-template-group" *ngIf="templatesOutros.length > 0">
          <h5>OUTROS</h5>
          <div class="reference-template-list">
            <div class="reference-template-row" *ngFor="let template of templatesOutros">
              <div class="reference-template-main">
                <div class="reference-template-icon utility" kendoTooltip title="Template aprovado&#10;Pronto para uso no WhatsApp">
                  <i class="fas fa-check"></i>
                </div>
                <div class="reference-template-copy">
                  <strong>{{ obtenhaDescricaoTipoNotificacao(template.tipoNotificacao) }}</strong>
                  <p>{{ template.textoMensagem || template.mensagem || 'Sem conteúdo de texto definido.' }}</p>
                </div>
              </div>
              <div class="reference-template-side">
                <span class="reference-template-status" [ngClass]="obtenhaClasseStatusTemplate(template.status || '')">
                  {{ obtenhaDescricaoStatusTemplate(template.status || '') }}
                </span>
                <span class="reference-template-category utility">$ Utilidade</span>
                <div class="reference-template-actions">
                  <button
                    *ngIf="podeExibirBotaoTesteTemplate(template)"
                    class="reference-template-test"
                    kendoTooltip
                    title="Enviar mensagem de teste"
                    [disabled]="!podeEnviarTesteTemplate(template) || enviandoTesteTemplate"
                    (click)="abrirModalEnviarTesteTemplate(template)">
                    <i class="fas" [ngClass]="enviandoTesteTemplateId === template.id ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                  </button>
                  <button class="reference-template-edit" (click)="abrirEditorTemplate(template)" title="Editar">
                    <i class="far fa-edit"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="reference-template-group" *ngIf="templatesMarketing.length > 0">
          <h5>MARKETING</h5>
          <div class="reference-template-list marketing-list">
            <div class="reference-template-row marketing-row" *ngFor="let template of templatesMarketing">
              <div class="reference-template-main">
                <div class="reference-template-icon marketing">
                  <i class="far fa-paper-plane"></i>
                </div>
                <div class="reference-template-copy">
                  <strong>{{ obtenhaDescricaoTipoNotificacao(template.tipoNotificacao) }}</strong>
                  <p>{{ template.textoMensagem || template.mensagem || 'Sem conteúdo de texto definido.' }}</p>
                </div>
              </div>
              <div class="reference-template-side">
                <span class="reference-template-status" [ngClass]="obtenhaClasseStatusTemplate(template.status || '')">
                  {{ obtenhaDescricaoStatusTemplate(template.status || '') }}
                </span>
                <span class="reference-template-category marketing">$$$ Marketing</span>
                <div class="reference-template-actions">
                  <button
                    *ngIf="podeExibirBotaoTesteTemplate(template)"
                    class="reference-template-test"
                    kendoTooltip
                    title="Enviar mensagem de teste"
                    [disabled]="!podeEnviarTesteTemplate(template) || enviandoTesteTemplate"
                    (click)="abrirModalEnviarTesteTemplate(template)">
                    <i class="fas" [ngClass]="enviandoTesteTemplateId === template.id ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
                  </button>
                  <button class="reference-template-edit" (click)="abrirEditorTemplate(template)" title="Editar">
                    <i class="far fa-edit"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="totalTemplatesFiltrados === 0" class="template-card-empty">
          <i class="fas fa-inbox"></i>
          <span *ngIf="buscaTemplates; else semTemplatesCadastrados">
            Nenhum template encontrado para "{{ buscaTemplates }}"
          </span>
          <ng-template #semTemplatesCadastrados>
            <span>Nenhum template encontrado</span>
          </ng-template>
        </div>
      </div>

      <div *ngIf="temTemplatesPendentes()" class="alert-banner alert-banner-warning">
        <i class="fas fa-clock"></i>
        <span>Alguns templates estão aguardando aprovação da Meta. Isso pode levar até 24 horas.</span>
      </div>

      <div *ngIf="temTemplatesRejeitados()" class="alert-banner alert-banner-danger">
        <i class="fas fa-exclamation-circle"></i>
        <span>Alguns templates foram rejeitados pela Meta. Entre em contato com o suporte.</span>
      </div>
    </div>

    <kendo-dialog
      class="template-test-modal"
      *ngIf="modalEnviarTesteTemplateAberto"
      [minWidth]="320"
      [width]="560"
      (close)="fecharModalEnviarTesteTemplate()">
      <kendo-dialog-titlebar (close)="fecharModalEnviarTesteTemplate()">
        <div class="template-test-dialog-titlebar">
          <span class="template-test-dialog-eyebrow">Teste de template</span>
          <strong class="template-test-dialog-title">Enviar teste</strong>
        </div>
      </kendo-dialog-titlebar>

      <div class="template-test-dialog">
        <div class="template-test-dialog-context">
          <span class="template-test-dialog-context-label">Template selecionado</span>
          <strong class="template-test-dialog-template-name">
            {{ obtenhaDescricaoTipoNotificacao(templateTesteSelecionado?.tipoNotificacao || '') || templateTesteSelecionado?.nome }}
          </strong>
          <p class="template-test-dialog-text">
            Informe um número autorizado para receber esta mensagem de teste.
          </p>
        </div>

        <div class="template-test-dialog-field">
          <label class="template-test-dialog-label" for="numeroAutorizadoTesteTemplateNovo">Número autorizado</label>
          <input
            id="numeroAutorizadoTesteTemplateNovo"
            type="text"
            inputmode="tel"
            autocomplete="tel"
            class="template-test-dialog-input"
            [(ngModel)]="numeroAutorizadoTesteTemplate"
            [disabled]="enviandoTesteTemplate"
            placeholder="Ex.: +55 11 99999-9999">
        </div>

        <p class="template-test-dialog-hint">
          Use um número autorizado no WhatsApp Cloud da conta de teste.
        </p>
      </div>

      <kendo-dialog-actions class="template-test-dialog-actions">
        <button
          class="k-button template-test-dialog-btn template-test-dialog-btn-secondary"
          (click)="fecharModalEnviarTesteTemplate()"
          [disabled]="enviandoTesteTemplate">
          Cancelar
        </button>
        <button
          class="k-button template-test-dialog-btn template-test-dialog-btn-primary"
          (click)="enviarTesteTemplate()"
          [disabled]="enviandoTesteTemplate">
          <i class="fas" [ngClass]="enviandoTesteTemplate ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
          {{ enviandoTesteTemplate ? 'Enviando...' : 'Enviar teste' }}
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </ng-container>
</div>
